import { render, staticRenderFns } from "./staking.vue?vue&type=template&id=f0b4f1ca&scoped=true&"
import script from "./staking.vue?vue&type=script&lang=js&"
export * from "./staking.vue?vue&type=script&lang=js&"
import style0 from "./staking.vue?vue&type=style&index=0&id=f0b4f1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b4f1ca",
  null
  
)

export default component.exports